<template>
  <div
    class="component-wrapper d-flex flex-column align-center justify-space-between"
  >
    <div
      class="d-flex flex-column pa-sm-12 pa-6 align-center rounded elevation-12"
    >
      <div class="mb-3">
        <img src="../assets/logotitle.png" alt="logo" class="logo" />
      </div>

      <div class="secondary--text text-center mb-8 form-title">
        ΥΠΟΒΟΛΗ ΕΚΘΕΣΕΩΝ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΧΡΗΜΑΤΑΓΟΡΑΣ
      </div>

      <v-form
        @submit.prevent="onSubmit"
        class="d-flex flex-column justify-center form"
      >
        <v-text-field
          v-model="email"
          label="Όνομα χρήστη"
          color="primary"
          prepend-inner-icon="mdi-account"
          class="mb-sm-2 mb-0"
        ></v-text-field>

        <v-text-field
          v-model="password"
          label="Συνθηματικό"
          type="password"
          color="primary"
          prepend-inner-icon="mdi-lock"
          class="mb-sm-2 mb-0"
        ></v-text-field>

        <div class="d-flex align-center justify-center">
          <v-btn
            type="submit"
            class="primary py-sm-6 py-3 mr-4"
            :loading="loader"
            :disabled="!email || !password"
            max-width="175px"
            width="100%"
            >Σύνδεση</v-btn
          >
        </div>
        <!-- <v-btn
          @click="$router.push('/forgotpass')"
          text
          plain
          small
          class="mt-2 ml-auto pa-0 secondary--text"
          >Ξεχάσατε το συνθηματικό σας;</v-btn
        > -->
      </v-form>
    </div>

    <Alert v-if="showAlert" :items="alertItems" class="mt-auto"></Alert>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Alert from "@/components/Alert.vue";
import { email } from "vuelidate/lib/validators";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      alertItems: {
        strong_text: "Σφάλμα! ",
        text: " Τα στοιχεία σύνδεσης είναι εσφαλμένα. Παρακαλώ προσπαθήστε ξανά ή επικοινωνήστε με την Επιτροπή Κεφαλαιαγοράς.",
        text_color: "error",
        dismissable: true,
      },
      email: "",
      password: "",
      showAlert: false,
      loader: false,
    };
  },

  validations: {
    email: {
      email,
    },
  },

  computed: {
    ...mapState({
      userRole: (state) => state.auth.userRole,
    }),
  },

  methods: {
    ...mapActions(["login"]),

    async onSubmit() {
      try {
        this.showAlert = false;
        this.loader = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          await this.login({
            userName: this.email,
            userPassword: this.password,
          });
        } else {
          await this.login({
            userEmail: this.email,
            userPassword: this.password,
          });
        }

        this.loader = false;

        if (this.userRole == "credit") this.$router.push({ path: "employees" });
        else if (this.userRole == "admin")
          this.$router.push({ path: "/admin/periods" });
        else if (this.userRole == "hcmc") this.$router.push({ path: "hcmc" });
      } catch (e) {
        this.loader = false;
        this.showAlert = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 400px;
  &-title {
    font-size: 20px;
    font-weight: 600;
  }
}

.logo {
  max-width: 100%;
}

.svg {
  width: 175px;
}

@media only screen and (max-width: 960px) {
  // .logo {
  //   width: 700px;
  // }
}

@media only screen and (max-width: 600px) {
  .form {
    width: 100%;
    &-title {
      font-size: 20px;
    }
  }
  .logo {
    width: 100%;
  }
  .svg {
    width: 133px;
  }
}

@media only screen and (max-width: 450px) {
  .form {
    &-title {
      font-size: 18px;
    }
  }
}
</style>